// Shop homepage carousel data

export const SHOPPING_HOME_CAROUSEL = [
  {
    title: 'Unbothered Editors\' Picks',
    image: '//www.refinery29.com/images/9920889.jpg?crop=3620%2C1358%2Cx0%2Cy374',
    overlay: '//s3.r29static.com//bin/public/600/x/2104663/image.png',
    collection_meta: 'BROWSING COLLECTIONS',
    text: '',
    product_count: '46',
    call_to_action: 'Unbothered Editors\' Picks',
    link: 'https://www.refinery29.com/en-us/shop/shop-unbothered-editors-picks-c2209535'
  },
  {
    title: 'Sleepy Sanctuary Buys From A To Zzzz',
    image: '//www.refinery29.com/images/8693358.jpg?crop=8%3A3',
    overlay: '//s3.r29static.com//bin/public/600/x/2104663/image.png',
    collection_meta: 'BROWSING COLLECTIONS',
    text: '',
    product_count: '55',
    call_to_action: 'Sleepy Sanctuary Buys From A To Zzzz',
    link: 'https://www.refinery29.com/en-us/shop/bedding-sleep-comfortably-c10678'
  },
  {
    title: 'Refinery29 Goods',
    image: '//www.refinery29.com/images/9920472.jpg?crop=6720%2C2520%2Cx0%2Cy1227',
    overlay: '//s3.r29static.com//bin/public/600/x/2104663/image.png',
    collection_meta: 'BROWSING COLLECTIONS',
    text: '',
    product_count: '12',
    call_to_action: 'Refinery29 Goods',
    link: 'https://www.refinery29.com/en-us/shop/products-designed-by-r29-c2209528'
  }
];
